var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-container"},[(_vm.isImage)?_c('img',{staticClass:"preview-img",attrs:{"src":_vm.previewLink,"alt":"Sertifika"}}):(_vm.isCertificationPreview)?_c('iframe',{staticClass:"preview-iframe",attrs:{"src":_vm.previewLink,"frameborder":"0"}}):(_vm.previewLink)?_c('PdfViewer',{attrs:{"src":_vm.previewLink}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }